<div class="migration-consent" *transloco="let t; prefix: 'migration-consent'">
    <div mat-dialog-title class="migration-consent__title">
        <h2>{{ t("headline") }}</h2>
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">
        <p>{{ t("completed") }}</p>
        <p>
            {{ t("reviewResponsibility") }} <strong>{{ t("reviewResponsibilityHighlight") }}</strong>
        </p>
        <p>
            {{ t("technicalResponsibility") }} <strong>{{ t("technicalResponsibilityHighlight") }}</strong>
        </p>
        <p>{{ t("inconsistencies") }}</p>
        <p>
            {{ t("legalBasis") }}
            <a [href]="licenseTermsUrl" target="_blank" rel="noopener noreferrer">{{ t("fullClauses") }}</a>
        </p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button [disabled]="submitting()" (click)="decide(false)">{{ t("refuse") }}</button>
        <button mat-flat-button color="primary" [disabled]="submitting()" (click)="decide(true)">
            {{ t("agree") }}
        </button>
    </mat-dialog-actions>
</div>
